import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPrivateProjectBankItemsOfProject } from 'scenes/ProjectBank/services/private-project-bank/getPrivateProjectBankItemsOfProject.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

export const loadPrivateProjectBankItemsOfProject = createAsyncThunk(
  'project-bank/loadPrivateProjectBankItemsOfProject',
  async (_, { getState }) => {
    const projectId = selectSelectedProjectId(getState());

    const privateProjectBankItems =
      await getPrivateProjectBankItemsOfProject(projectId);

    return privateProjectBankItems;
  }
);
